module.exports = __webpack_public_path__ + "img/logo-light-xs.6027fe33.svg";